import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { getApproval as query } from '../graphql/approvals';
import apolloClient from '../../utils/apollo-client';

export default async function getHRApproval({ uuid }) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.getApprovalAndApplication(uuid);
  }
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { uuid }
    })
  );
  return response.data?.getApproval;
}
